import React, { useContext } from 'react';
import styled from 'styled-components';
import { Form, Title } from 'components';
import LabelledSwitch from '../LabelledSwitch';
import ForwardMessages from './ForwardMessages';
import ForwardCalls from './ForwardCalls';
import VacationDates from './VacationDates';
import OtherSection from '../OtherSection';
import FormContext from '../FormContext';

const FrontDeskInstructionsTab = () => {
  const { userState, setUserState, showForwardReps, setShowForwardReps } =
    useContext(FormContext);

  const toggleForwardCalls = (checked: boolean) => {
    setUserState(prev => ({
      ...prev,
      frontEndInstructions: {
        ...prev.frontEndInstructions,
        forwardCalls: {
          ...prev.frontEndInstructions.forwardCalls,
          enabled: checked,
        },
      },
    }));
  };

  const toggleVacationDates = (checked: boolean) => {
    setUserState(prev => ({
      ...prev,
      frontEndInstructions: {
        ...prev.frontEndInstructions,
        vacationDates: {
          enabled: checked,
        },
      },
    }));
  };

  const toggleReleaseMobile = (checked: boolean) => {
    setUserState(prev => ({
      ...prev,
      frontEndInstructions: {
        ...prev.frontEndInstructions,
        releaseCell: checked,
      },
    }));
  };

  const toggleForwardReps = (checked: boolean) => {
    setShowForwardReps(checked);
    setUserState(prev => ({
      ...prev,
      frontEndInstructions: {
        ...prev.frontEndInstructions,
        forwardReps: checked ? [{ id: undefined }] : [],
      },
    }));
  };

  const showVacationDates =
    userState.frontEndInstructions?.vacationDates?.enabled;
  const showForwardCalls =
    userState.frontEndInstructions?.forwardCalls?.enabled;

  return (
    <Form layout="vertical">
      <Title level={3} hideMargin>
        Forward Office Messages
      </Title>
      <Spacer $height={20} />
      <LabelledSwitch
        data-cy="front-desk-release-mobile-number-switch"
        labelText="Release my mobile number"
        checked={userState.frontEndInstructions?.releaseCell}
        onChange={toggleReleaseMobile}
      />

      <Spacer $height={24} />
      <LabelledSwitch
        data-cy="front-desk-forwarding-on-switch"
        labelText="Forwarding On"
        checked={showForwardReps}
        onChange={toggleForwardReps}
      />
      {showForwardReps && <ForwardMessages />}

      <Spacer $height={24} />
      <LabelledSwitch
        data-cy="front-desk-forwarding-calls-switch"
        labelText="Forward calls"
        checked={showForwardCalls}
        onChange={toggleForwardCalls}
      />
      {showForwardCalls && <ForwardCalls />}

      <Spacer $height={24} />
      <LabelledSwitch
        data-cy="front-desk-set-vacation-dates-switch"
        labelText="Set vacation dates"
        checked={showVacationDates}
        onChange={toggleVacationDates}
      />
      {showVacationDates && <VacationDates />}

      <Spacer $height={24} />
      <Title level={3} hideMargin>
        Other
      </Title>

      <OtherSection />
      <Spacer $height={24} />

      <Spacer $height={24} />
    </Form>
  );
};

export default FrontDeskInstructionsTab;

const Spacer = styled.div<{ $height: number }>`
  ${({ $height }) => `height: ${$height}px;`}
  width: 100%;
`;
